import axios from "../utils/request";

const base_Url = "/bluetoothlight/web/";

// 登录
const login = function(data = {}) {
  return axios({
    method: "post",
    url: base_Url + `common/login`,
    data
  });
};
// 登出
const logout = function(data) {
  return axios({
    method: "post",
    url: base_Url + `common/logout`,
  });
};
// 验证码
const codeGet = function() {
  return axios({
    method: "get",
    url: base_Url + `common/imagecode`,
    responseType: 'arraybuffer'
  });
};
// 修改密码
const modifypwd = function(data) {
  return axios({
    method: "post",
    url: base_Url + `common/modifypwd`,
    data
  });
};

// 修改密码
const STSToken = function(data) {
  return axios({
    method: "get",
    url: base_Url + `common/oss/auth`,
    data
  });
};

const getNccDownloadUrl = function(){
  return axios({
    method: "get",
    url: base_Url + `system-config/getNccUrl`
  });
}

const updateNccDownloadUrl = function(data){
  return axios({
    method: "post",
    url: base_Url + `system-config/updateNccDownloadUrl`,
    data
  });
}

// 获取版本列表
const getVersionList = function(params){
  console.log(获取版本列表,params)
  return axios({
    method: "get",
    url: base_Url + `system-config/version/list`,
    params
  });
}

// 获取版本详情
const getById = function(id){
  return axios({
    method: "get",
    url: base_Url + `system-config/getById?id=${id}`
  });
}

// 新增版本
const addAppName = function(data){
  return axios({
    method: "post",
    url: base_Url + `system-config/add`,
    data
  });
}

// 更新版本
const updateAppName = function(data){
  return axios({
    method: "post",
    url: base_Url + `system-config/update`,
    data
  });
}

// 删除版本
const deleteAppName = function(id){
  return axios({
    method: "get",
    url: base_Url + `system-config/delete?id=${id}`
  });
}

// 获取APP名称列表
const getAppNames = function(){
  return axios({
    method: "get",
    url: base_Url + `system-config/names`
  });
}

const resetPassword = function(data){
  return axios({
    method: "post",
    url: base_Url + `router/neewerapp/Login/ResetPwd`,
    data
  });
}

const sendResetCode = function(data){
  return axios({
    method: "post",
    url: base_Url + `router/neewerapp/Login/GetVerificationCode`,
    data
  });
}

export {
  login,
  logout,
  codeGet,
  modifypwd,
  STSToken,
  getNccDownloadUrl,
  updateNccDownloadUrl,
  resetPassword,
  sendResetCode,
  getVersionList,
  getById,
  addAppName,
  updateAppName,
  deleteAppName,
  getAppNames
};
